import { useEffect, useMemo, useState } from 'react';
import { useOrderBookDataById } from '@/lib/hooks/useOrderBookServiceById';
import { MarketIntent } from '@/lib/types/market-intent';
import { OrderBookItem } from '@/lib/types/order-book';
import { maxBy, minBy } from '@/lib/utils/numbers';

// expensive calculations. Should happen only for currently active order book that is reveled in the UI
export const useOrderBookDisplayData = (outcomeId: string, intent: MarketIntent = 'yes') => {
  const orderBook = useOrderBookDataById(outcomeId);
  const [initialised, setInitialised] = useState(false);
  const [bids, setBids] = useState<OrderBookItem[]>([]);
  const [asks, setAsks] = useState<OrderBookItem[]>([]);

  useEffect(() => {
    if (!orderBook) {
      return;
    }
    setBids(orderBook[intent].bids);
    setAsks(orderBook[intent].asks);
    setInitialised(true);
  }, [intent, orderBook]);

  return useMemo(() => {
    const data = {
      bids,
      asks,
      marketId: outcomeId,
      initialised,
    };

    const maxBid = maxBy(data.bids, (bid) => bid.price);
    const minAsk = minBy(data.asks, (ask) => ask.price);
    return { ...data, maxBid, minAsk };
  }, [asks, bids, initialised, outcomeId]);
};
